"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.MessageQoS = void 0;
var MessageQoS;
(function (MessageQoS) {
    MessageQoS[MessageQoS["AtMostOnce"] = 0] = "AtMostOnce";
    MessageQoS[MessageQoS["AtLeastOnce"] = 1] = "AtLeastOnce";
    MessageQoS[MessageQoS["ExactlyOnce"] = 2] = "ExactlyOnce";
})(MessageQoS = exports.MessageQoS || (exports.MessageQoS = {}));
